
import SearchByFilters from "./SearchByFilters";

export default function() {
    const self = this;

    self.collection = [];


    /**
     * Returns a specific search by filters object
     * @param id
     * @returns {*}
     */
    self.get = (id) => {
        if(typeof self.collection[id] !== 'undefined') {
            return self.collection[id];
        }
        return null;
    };

    /**
     * Store a specific search by filters to the global collection
     * @param {String} id
     * @param {SearchByFilters} searchByFilters
     * @return {void}
     */
    self.set = (id, searchByFilters) => {
        if(!searchByFilters instanceof SearchByFilters) {
            console.error('Search by filters must be instance of SearchByFilters');
            return;
        }

        self.collection[id] = searchByFilters;
    };




}


// WEBPACK FOOTER //
// ./resources/js/MrMovie/SearchByFiltersCollection.js